import React from 'react'

//STYLES
import './ContactCard.css'

export default function ContactCard({contact}) {
  return (
    <div className='contact-card shadowed'>
        <p className='name'>{contact.name}</p>
        <ul>
            {contact.tel && 
            <li className='tel'>{contact.tel}</li>}
            {contact.mail && 
            <li className='mail'>
                <a href={`mailto:${contact.mail}`}>E-Mail</a>
            </li>}
        </ul>
    </div>
  )
}
